import { render, staticRenderFns } from "./CartSuggestions.vue?vue&type=template&id=2c7e6330&scoped=true&"
import script from "./CartSuggestions.vue?vue&type=script&lang=js&"
export * from "./CartSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./CartSuggestions.vue?vue&type=style&index=0&id=2c7e6330&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7e6330",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
